<template>
  <div
    class="main"
    style="height: 100%;position: relative;">

    <header class="row align-items-center no-margin">
      <div class="col"/>
    </header>

    <button
      class="btn btn-newsale"
      @click="onClickDone()">
      {{ $t('message.newsale') }}
    </button>

    <section class="section">

      <div class="wrapper-change row no-margin">
        <div class="icon col-12 text-center">
          <i class="fas fa-clipboard-check"/>
        </div>
        <div class="change col-12 text-center text-success">
          {{ $t('apps.pos.message.insertposbillsuccess') }}
        </div>
        <div
          v-if="this.receiptInfo.paymentMethod === POS_PAYMENT_METHOD.CASH"
          class="paid col-12 text-center"
        >
          <span
            v-html="$t('apps.pos.message.changecash', {
              number1: getNumber(receiptInfo.change),
              number2: getNumber(receiptInfo.paid),
          })"/>
        </div>
      </div>

      <div
        v-if="showQrCodeReceipt"
        class="wrapper-scan-qrcode">
        <div class="inner">
          <img :src="qrcodeReceiptDataUrl">
          <div class="message">
            <span>
              {{ $t('message.scandownloadreceipt') }}
            </span>
            <i class="fas fa-level-down-alt"/>
          </div>
        </div>
      </div>

      <div class="wrapper-action row">
        <div
          class="text-header col-12 text-center"
          style="margin-top: 15px;">
          {{ $t('apps.pos.message.howdoyouwantreceipts') }}
        </div>
        <div class="outer-input row col-12">
          <div class="inner-input col-3 row text-center">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span
                  id="basic-addon1"
                  class="input-group-text">
                  <i class="fas fa-envelope"/>
                </span>
              </div>
              <input
                v-model="email"
                :placeholder="$t('placeholder.email')"
                type="text"
                class="form-control"
                aria-describedby="basic-addon1">
            </div>
            <template>
              <button
                v-if="isSendingEmail"
                :disabled="true"
                class="btn btn-sendmail"
              >
                <i class="fas fa-spinner spin"/>
              </button>
              <button
                v-else
                :disabled="email.trim().length === 0"
                class="btn btn-sendmail"
                @click="onclickSentEmail()"
              >
                {{ $t('button.send') }}
              </button>
            </template>
          </div>
        </div>
        <div
          v-if="posSettings.qrcode_receipt.auto === false"
          class="outer-input row col-12">
          <div
            class="inner-input col-3 row text-center"
            style="cursor: pointer;"
            @click="setQRCodeDataUrl()">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i
                    class="fas fa-qrcode"
                    style="position: relative;left: 2px;"/>
                </span>
              </div>
              <span class="message">{{ $t('message.showqrcodebutton') }}</span>
            </div>
          </div>
        </div>
        <div class="outer-input row col-12">
          <div
            class="inner-input col-3 row text-center"
            style="cursor: pointer;"
            @click="onclickPrint()">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="fas fa-print"/>
                </span>
              </div>
              <span class="message">{{ $t('message.printreceipt') }}</span>
            </div>
          </div>
        </div>
        <div class="outer-input row col-12">
          <div
            class="inner-input col-3 row text-center"
            style="cursor: pointer;"
            @click="onClickDone()">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="fas fa-ban"/>
                </span>
              </div>
              <span class="message">{{ $t('message.nothanks') }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <receipt-view
      :shop_logo="receiptInfoProps.shopLogo"
      :shop_name="receiptInfoProps.shopName"
      :shop_address="receiptInfoProps.shopAddress"
      :shop_tax_id="receiptInfoProps.shopTaxId"
      :shop_tax_title="receiptInfoProps.shopTaxTitle"
      :shop_tel="receiptInfoProps.shopTel"
      :orders="receiptInfoProps.orders"
      :total_price="receiptInfoProps.totalPrice"
      :receipt_info="receiptInfoProps.receiptInfo"
      :date_time="receiptInfoProps.dateTime"
      :text_footer="receiptInfoProps.textFooter"
      :font_size="receiptInfoProps.fontSize"
      class="receipt-template"
      style="position: fixed;z-index: -1;top: 1mm;left: 1mm;font-family: tahoma;color: black;width: 100%;"
    />

  </div>
</template>

<script>
import paymentComplateMixin from '@/mixins/pos/paymentComplate'

export default {
  mixins: [paymentComplateMixin],
}
</script>

<style scoped>
  .section {
    position: relative;
  }
  .section .wrapper-change .icon {
    font-size: 110px;
    color: #BBBBBB;
  }
  .section .wrapper-change .change {
    font-size: 24px;
  }
  .section .wrapper-change .paid {
    font-size: 48px;
  }
  .section .wrapper-change .paid /deep/ .receipt {
    font-size: 40%;
  }
  .wrapper-action {
    margin: 40px 0 0 0;
  }
  .wrapper-scan-qrcode {
    margin: 40px 0 0 0;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .wrapper-scan-qrcode .inner {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .wrapper-scan-qrcode .inner .message {
    font-size: 13px;
    margin-top: 5px;
    position: absolute;
    left: 160px;
    min-width: 200px;
    display: flex;
    flex-direction: column;
  }
  .wrapper-scan-qrcode .inner .message i {
    width: 18px;
    height: 18px;
    font-size: 18px;
    transform: rotate(90deg);
    position: relative;
    top: 5px;
  }
  .wrapper-scan-qrcode img {
    max-width: 150px;
  }
  .btn-newsale {
    position: absolute;
    z-index: 2;
    top: 20px;
    right: 20px;
    background: #F6F8FA;
    border: solid 1px #D8E2E7;
    font-size: 20px;
    color: #000;
  }
  .wrapper-action .outer-input {
    margin: 0 0 10px 0;
  }
  .wrapper-action .outer-input .inner-input {
    position: relative;
    height: 42px;
    padding: 0;
    margin: auto;
    background: #fff;
    border: solid 1px #D8E2E7;
  }
  .wrapper-action .outer-input .inner-input .input-group {
    height: 100%;
    position: relative;
    z-index: 1;
  }
  .wrapper-action .outer-input .inner-input .input-group-text, .wrapper-action .outer-input .inner-input input {
    border: none;
    background: #fff;
  }
  .wrapper-action .outer-input .inner-input input {
    padding-left: 0;
  }
  .wrapper-action .outer-input .inner-input .input-group-text i {
    font-size: 22px;
  }
  .wrapper-action .outer-input .inner-input .message {
    position: relative;
    top: 9px;
  }
  .wrapper-action .outer-input .inner-input button.btn-sendmail {
    position: absolute;
    z-index: 2;
    top: 6px;
    right: 6px;
    padding: 3px 10px 3px 10px;
    background: #F6F8FA;
    border-radius: 4px;
    border: solid 1px #D8E2E7;
    font-size: 14px;
    cursor: pointer;
  }
  .wrapper-action .outer-input .inner-input button.btn-sendmail.disabled {
    background: #F8F8F8;
    color: #BBBBBB;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/main/include/PaymentComplate.vue